module.exports = __webpack_public_path__ + "static/media/7x7BadOptimized.9148afd1.jp2";